<template>
	<v-dialog class="dialog-bx" scrollable scroll-strategy="reposition" :fullscreen="$vuetify.display.smAndDown"
		v-model="instructionsDialog" max-width="800px" min-height="400px" max-height="1000px">
		<v-card height="700px" color="background">
			<v-card-text>
				<v-row justify="space-around" class="mt-3 ml-2">
					<v-col cols="10">
						<v-row>
							<v-icon class="mr-3"> mdi-note-multiple-outline </v-icon>
							<span class="t-h5">{{ startTestInfo.testmetadata.testName }}
							</span>
						</v-row>
					</v-col>
					<v-col align-self="end" offset="1" cols="1">
						<v-icon @click="instructionsDialog = false"> mdi-close </v-icon>
					</v-col>
				</v-row>
				<v-row class="mt-5 mb-6">
					<v-divider></v-divider>
				</v-row>
				<v-row class="px-4">
					<HtmlRender class="htmlClass" :html-string="currentSection.instructions"></HtmlRender>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
	<v-dialog v-model="warningDialog" class="dialog-bx" width="auto">
		<v-card>
			<v-card-title class="t-h5 text-capitalize">
				{{ this.warningTimeLeft }} mins remaning
				<v-divider class="mt-3"> </v-divider>
			</v-card-title>
			<v-card-text class="mb-3">Only {{ this.warningTimeLeft }} mins are left to complete the
				test</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>

				<v-btn color="primary" variant="text" @click="warningDialog = false">
					Okay
				</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>

	<v-app-bar color="navbar">
		<v-app-bar-title>
			<template v-slot:text>
				<span class>
					{{ startTestInfo.testmetadata.testName }}
				</span>
				<span v-if="currentSection.visibleOnApp">
					| {{ currentSection.sectionName }}
				</span>
			</template>
		</v-app-bar-title>

		<v-spacer></v-spacer>

		<v-icon v-if="!timeOver" class="mr-4" :color="remaningTimeInSeconds < 120 ? 'red' : 'white'">
			mdi-clock-outline</v-icon>
		<div v-if="!timeOver" class="mr-5" :class="{ 'text-red blink': remaningTimeInSeconds < 120 }">
			{{ getRemainingTime }}
		</div>
		<v-menu class="mr-5">
			<template v-slot:activator="{ props }">
				<v-btn color="white" icon="mdi-dots-vertical" v-bind="props"> </v-btn>
			</template>
			<v-list>
				<v-list-item @click="showTestInstructionsDialog()">
					<v-list-item-title>Test Instructions</v-list-item-title>
				</v-list-item>
				<v-list-item @click="exitTest()">
					<v-list-item-title>Exit Test</v-list-item-title>
				</v-list-item>
			</v-list>
		</v-menu>
	</v-app-bar>
	<v-dialog class="dialog-bx" :fullscreen="$vuetify.display.smAndDown" v-model="testInstructionsDialog"
		max-width="800px" min-height="400px" max-height="1000px">
		<v-card height="700px" color="background">
			<v-card-text>
				<v-row justify="space-around" class="mt-3 ml-2">
					<v-col cols="10">
						<v-row>
							<v-icon class="mr-3"> mdi-note-multiple-outline </v-icon>
							<span class="t-h5">
								{{ startTestInfo.testmetadata.testName }}
							</span>
						</v-row>
					</v-col>
					<v-col align-self="end" offset="1" cols="1">
						<v-icon @click="testInstructionsDialog = false"> mdi-close </v-icon>
					</v-col>
				</v-row>
				<v-row class="mt-5 mb-6">
					<v-divider></v-divider>
				</v-row>
				<v-row class="px-4">
					<HtmlRender class="htmlClass" :html-string="startTestInfo.testmetadata.instructions"></HtmlRender>
				</v-row>
			</v-card-text>
		</v-card>
	</v-dialog>
	<div v-if="reviewScreen">
		<section class="mx-5 mt-4">
			<v-alert type="warning" title="Please try submitting again" v-if="showSubmitAlert" class="mx-8 mt-4 mb-8"
				text="There was an issue, please try submitting again"></v-alert>
			<v-alert type="error" title="Please try attempting previous question again!" v-if="showQuestionAttemptAlert"
				class="mx-8 mt-4 mb-8"
				text="Error has occurred while saving previous question to server. Please check your internet connection or try attempting previous question again. If this issue still persists, please contact LMS Support Team!"></v-alert>

			<div class="mb-8">
				<v-row v-if="!timeOver" class="align-center" justify="center">
					<v-col cols="12" class="text-center t-h5 timer">
						Remaining Time
					</v-col>
				</v-row>
				<v-row v-if="!timeOver" class="align-center mt-0 pt-0" justify="center">
					<v-col cols="12" class="text-center t-h6 font-weight-bold timer-color">
						{{ getRemainingTime }}
					</v-col>
				</v-row>
				<v-row class="align-center mt-4" justify="center">
					<v-col cols="12" class="t-h5 text-center">
						<span v-if="timeOver">
							Test time is over, please submit the test
						</span>
						<span v-else> Are you sure you want to submit the test ? </span>
					</v-col>
				</v-row>
				<v-row class="align-center" justify="center">
					<v-col cols="12" class="mt-n5 text-center t-h6Reg">
						<span v-if="timeOver">
							Test will be auto submitted in {{ submitFormattedTime }}
						</span>
						<span v-else> you will not be able to edit upon submission </span>
					</v-col>
				</v-row>
				<v-row justify="center" class="mt-10">
					<v-col cols="12" md="10" lg="8" xl="6">
						<v-row>
							<v-col cols="12" class="t-h5Reg text-center mb-4">
								Do you want to review marked questions before submitting ?
							</v-col>
						</v-row>

						<v-card elevation="0" class="card-bg-color">
							<v-card-text class="pa-8 mt-5">
								<v-row>
									<v-col cols="auto" class="">
										<v-avatar size="40" variant="outlined" class="mr-2 correct">
											{{ questionCounts.answered }} </v-avatar><span> Answered </span>
									</v-col>
									<v-col cols="auto" class="">
										<v-avatar size="40" variant="outlined" class="mr-2 unanswered">
											{{ questionCounts.unanswered }} </v-avatar><span> Not Answered </span>
									</v-col><v-col cols="auto" class="">
										<v-avatar size="40" variant="outlined" class="mr-2 marked">
											{{ questionCounts.marked }} </v-avatar><span> Marked For Review </span>
									</v-col>
								</v-row>
								<v-row>
									<v-divider class="my-5"> </v-divider>
								</v-row>

								<v-row class="my-4" v-for="(item, sIndex) in qResponsesState" :key="sIndex">
									<v-col v-if="item.visibleOnApp" cols="12" class="t-h5Reg">
										{{ item.sectionName }}
									</v-col>

									<v-row>
										<v-col cols="auto" class="mx-2" v-for="(item, qIndex) in item.responses"
											:key="qIndex">
											<v-avatar style="cursor: pointer" @click="
												timeOver ? null : openQFromReview(sIndex, qIndex)
												" size="40" variant="outlined" :class="{
													correct: checkIfQuestionAnswered(item),
													marked: item.markedForReview,
													unanswered: !checkIfQuestionAnswered(item),
												}">
												{{ item.qNo }}
											</v-avatar>
										</v-col>
									</v-row>
								</v-row>
							</v-card-text>
						</v-card>
					</v-col>
				</v-row>
				<v-row class="align-center mt-8" justify="center" v-if="testSubmitError">
					<v-col cols="auto">
						<v-btn @click="triggerResponseFileDownload" size="large" color="success">Download Response
							file</v-btn>
					</v-col>
				</v-row>
				<v-row class="align-center mt-8" justify="center">
					<v-col cols="auto">
						<v-btn width="140" class="correct t-btn text-capitalize btn-rd" @click="submitTest()"
							variant="flat">
							Yes, Submit
						</v-btn>
					</v-col>
					<v-col cols="auto">
						<v-btn @click="backFromReview()" :color="!timeOver ? 'secondaryBackground' : undefined"
							:disabled="timeOver" class="t-btn text-capitalize btn-rd" width="140" variant="flat">
							No, Wait
						</v-btn>
					</v-col>
				</v-row>

			</div>
		</section>
	</div>

	<div v-else class="">
		<v-dialog absolute class="bottom dialog-bx" height="700px" width="800px" v-model="questionDialog">
			<v-card height="700px" color="background">
				<v-card-text class="pa-8">
					<v-row justify="space-between" class="t-h5 px-3">
						<v-col class="ml-0 pl-0"> Your Responses </v-col>
						<v-col class="text-right">
							<v-icon @click="questionDialog = false"> mdi-close </v-icon>
						</v-col>
					</v-row>
					<v-row>
						<v-divider class="mt-2 mb-5"> </v-divider>
					</v-row>
					<v-row>
						<v-col cols="auto" class="">
							<v-avatar size="40" variant="outlined" class="mr-2 correct">
								{{ questionCounts.answered }} </v-avatar><span> Answered </span>
						</v-col>
						<v-col cols="auto" class="">
							<v-avatar size="40" variant="outlined" class="mr-2 unanswered">
								{{ questionCounts.unanswered }} </v-avatar><span> Not Answered </span> </v-col><v-col
							cols="auto" class="">
							<v-avatar size="40" variant="outlined" class="mr-2 marked">
								{{ questionCounts.marked }} </v-avatar><span> Marked For Review </span>
						</v-col>
					</v-row>
					<v-row>
						<v-divider class="my-5"> </v-divider>
					</v-row>

					<v-row class="my-4 mb-8" v-for="(item, sIndex) in qResponsesState" :key="sIndex" align="center">
						<v-col v-if="item.visibleOnApp" cols="12" class="t-h5Reg mb-2">
							<v-row align="center">
								<v-col cols="12" sm="auto" class="ma-0 pa-0">
									{{ item.sectionName }}
								</v-col>
								<v-col cols="12" sm="auto" class="ma-0 pa-0 ml-0 ml-sm-2">
									<span class="t-h5Reg text-primary" v-if="item.restrictAttemptToMaxQuestion">
										| Max questions allowed - {{ item.maxQuestionToAttempt }}
									</span>
								</v-col>
							</v-row>
						</v-col>

						<v-row>
							<v-col cols="auto" class="mx-2" v-for="(item, qIndex) in item.responses" :key="qIndex">
								<v-avatar style="cursor: pointer" @click="openQFromDialog(sIndex, qIndex)" size="40"
									variant="outlined" :class="{
										correct: checkIfQuestionAnswered(item),
										marked: item.markedForReview,
										unanswered: !checkIfQuestionAnswered(item),
									}">
									{{ item.qNo }}
								</v-avatar>
							</v-col>
						</v-row>
					</v-row>
				</v-card-text>
			</v-card>
		</v-dialog>

		<v-container fluid>
			<v-card elevation="0" class="pb-14">
				<v-alert type="error" title="Please try attempting previous question again!"
					v-if="showQuestionAttemptAlert" class="mx-8 mt-4 mb-8"
					text="Error has occurred while saving previous question to server. Please check your internet connection or try attempting previous question again. If this issue still persists, please contact LMS Support Team!"></v-alert>
				<section class="mx-5 mt-10">
					<div class="mb-8">
						<v-row class="align-center">
							<span class="mx-3 qNoClass"> Question {{ currentQ.qNo }} </span>
							<div @click="eventCaptureForMarkReview" class="ml-5"
								v-if="currentQResponse.markedForReview">
								<v-tooltip text="Mark For Review" location="start">
									<template v-slot:activator="{ props }">
										<v-btn elevation="0" theme="dark" v-bind="props" size="small"
											@click="currentQResponse.markedForReview = false" color="#FF894F"
											icon="mdi-flag"></v-btn>
									</template>
								</v-tooltip>
							</div>
							<div @click="eventCaptureForMarkReview" class="ml-5" v-else>
								<v-tooltip text="Mark For Review" location="start">
									<template v-slot:activator="{ props }">
										<v-btn size="small" v-bind="props" class="outline-color" variant="outlined"
											@click="currentQResponse.markedForReview = true"
											icon="mdi-flag-outline"></v-btn>
									</template>
								</v-tooltip>
							</div>
							<div class="ml-5">
								<v-tooltip text="Section Instructions" location="end">
									<template v-slot:activator="{ props }">
										<v-btn size="small" v-bind="props" v-if="currentSection.showSectionInstructions"
											class="outline-color" variant="outlined" @click="showInstructions()"
											icon="mdi-information-variant"></v-btn>
									</template>
								</v-tooltip>
							</div>
						</v-row>
					</div>

					<section>
						<div v-html="getMarkDownHtml(currentQ.qText)" class="htmlClassTest overflow-auto"></div>
					</section>

					<div cla ss="mt-15">
						<v-row class="mt-4 mb-10 mx-1">
							<v-alert color="info" icon="$info" variant="tonal" v-model="showAttemptedDialog"
								text="You have already attempted maximum number of questions in the given section"></v-alert>
						</v-row>
						<!-- case 1 -->
						<section v-if="currentQ.qType == '1'">
							<v-radio-group v-model="currentQResponse.checkedOption">
								<v-row v-for="option in currentQ.options" :key="option.key">
									<v-col @click="eventCaptureForQTypeOne(option)" cols="12">
										<v-hover v-slot="{ isHovering, props }">
											<v-sheet :class="{ 'on-hover': isHovering }" v-bind="props"
												class="pa-0 pl-2 ma-0 bx">
												<v-radio :disabled="disableQuestion" density="compact" color="primary"
													class="ma-0 pa-0 w-100 pr-3 testOption" dense :value="option.key">
													<template v-slot:label>
														<div class="htmlClassTest htmlClassTestOption ml-1 py-4 w-100"
															v-html="getMarkDownHtml(option.value)"></div>
													</template>
												</v-radio>
											</v-sheet>
										</v-hover>
									</v-col>
								</v-row>
							</v-radio-group>
						</section>

						<section v-if="currentQ.qType == '2'">
							<v-row v-for="option in currentQ.options" :key="option.key">
								<v-col @click="eventCaptureForQTypeTwo(option)" cols="12">
									<v-hover v-slot="{ isHovering, props }">
										<v-sheet :class="{ 'on-hover': isHovering }" v-bind="props"
											class="pa-0 pl-2 ma-0 bx">
											<v-checkbox :disabled="disableQuestion" density="compact" multiple
												hide-details size color="primary"
												v-model="currentQResponse.checkedOptions"
												class="tqp ma-0 pa-0 w-100 testOption pr-3" dense :value="option.key">
												<template v-slot:label>
													<div class="htmlClassTest htmlClassTestOption ml-1 py-4 w-100"
														v-html="getMarkDownHtml(option.value)"></div>
												</template>
											</v-checkbox>
										</v-sheet>
									</v-hover>
								</v-col>
							</v-row>
						</section>

						<section v-if="currentQ.qType == '3'">
							<v-row>
								<v-col cols="8" md="3" lg="2">
									<v-text-field :disabled="disableQuestion" label="Answer" @input="validateInput"
										:error-messages="validationErrors" v-model="currentQResponse.integerOption"
										variant="outlined" readonly @keydown.prevent></v-text-field>
								</v-col>
							</v-row>
							<v-row v-if="!disableQuestion">
								<div class="numeric-input" :style="{
									width: '230px',
									height: '300px',
									marginLeft: '15px',
								}">
									<div class="input-charactors">
										<button class="backspace-btn" @click="removeLastCharacter">
											Backspace
										</button>
										<div class="buttons">
											<button class="text-input-btn" @click="appendValue(1)">
												1
											</button>
											<button class="text-input-btn" @click="appendValue(2)">
												2
											</button>
											<button class="text-input-btn" @click="appendValue(3)">
												3
											</button>
											<button class="text-input-btn" @click="appendValue(4)">
												4
											</button>
											<button class="text-input-btn" @click="appendValue(5)">
												5
											</button>
											<button class="text-input-btn" @click="appendValue(6)">
												6
											</button>
											<button class="text-input-btn" @click="appendValue(7)">
												7
											</button>
											<button class="text-input-btn" @click="appendValue(8)">
												8
											</button>
											<button class="text-input-btn" @click="appendValue(9)">
												9
											</button>
											<button class="text-input-btn" @click="appendValue(0)">
												0
											</button>
											<button class="text-input-btn" @click="appendValue('.')">
												.
											</button>
											<button class="text-input-btn" @click="appendValue('-')">
												-
											</button>
										</div>
										<button class="clear-btn" @click="clearInput">Clear</button>
									</div>
								</div>
							</v-row>
						</section>

						<section v-if="currentQ.qType == '4'">
							<v-row>
								<v-col cols="8" md="3" lg="2">
									<v-text-field :disabled="disableQuestion" label="Answer" @input="validateInput"
										:error-messages="validationErrors" v-model="currentQResponse.decimalOption"
										variant="outlined" readonly @keydown.prevent></v-text-field>
								</v-col>
							</v-row>

							<v-row v-if="!disableQuestion">
								<div class="numeric-input" :style="{
									width: '230px',
									height: '300px',
									marginLeft: '15px',
								}">
									<div class="input-charactors">
										<button class="backspace-btn" @click="removeLastCharacter">
											Backspace
										</button>
										<div class="buttons">
											<button class="text-input-btn" @click="appendValue(1)">
												1
											</button>
											<button class="text-input-btn" @click="appendValue(2)">
												2
											</button>
											<button class="text-input-btn" @click="appendValue(3)">
												3
											</button>
											<button class="text-input-btn" @click="appendValue(4)">
												4
											</button>
											<button class="text-input-btn" @click="appendValue(5)">
												5
											</button>
											<button class="text-input-btn" @click="appendValue(6)">
												6
											</button>
											<button class="text-input-btn" @click="appendValue(7)">
												7
											</button>
											<button class="text-input-btn" @click="appendValue(8)">
												8
											</button>
											<button class="text-input-btn" @click="appendValue(9)">
												9
											</button>
											<button class="text-input-btn" @click="appendValue(0)">
												0
											</button>
											<button class="text-input-btn" @click="appendValue('.')">
												.
											</button>
											<button class="text-input-btn" @click="appendValue('-')">
												-
											</button>
										</div>
										<button class="clear-btn" @click="clearInput">Clear</button>
									</div>
								</div>
							</v-row>
						</section>
					</div>
				</section>
			</v-card>
		</v-container>
	</div>
	<v-footer v-if="!reviewScreen" app class="bg-background">
		<v-row justify="space-between" class="pa-5 align-center">
			<v-col class="align-center">
				<v-btn size="large" v-if="$vuetify.display.mdAndUp" class="t-btn text-capitalize btn-rd"
					:disabled="prevButtonDisabled" width="130" @click="prevQuestion" elevation="0"
					:color="!prevButtonDisabled ? 'secondaryBackground' : undefined">
					Previous
					<template v-slot:prepend>
						<v-icon>mdi-chevron-left</v-icon>
					</template>
				</v-btn>

				<v-btn v-else density="compact" :size="$vuetify.display.mdAndDown && $vuetify.display.width > 400
					? 'large'
					: 'default'
					" icon="mdi-chevron-left" :disabled="prevButtonDisabled" @click="prevQuestion">
				</v-btn>

				<v-btn v-if="$vuetify.display.mdAndUp" size="large" class="t-btn text-capitalize ml-4"
					@click="clearResponse" elevation="0" color="transparent">
					Clear
					<template v-slot:prepend>
						<v-icon>mdi-rotate-right</v-icon>
					</template>
				</v-btn>
				<v-btn v-else class="ml-4 mt-1" density="compact" :size="$vuetify.display.mdAndDown && $vuetify.display.width > 400
					? 'large'
					: 'small'
					" icon="mdi-rotate-right" @click="clearResponse" elevation="0">
				</v-btn>
			</v-col>

			<v-col cols="auto">
				<v-btn @click="openQuestionDialog()" color="secondaryBackground" density="compact" elevation="0" :size="$vuetify.display.mdAndDown && $vuetify.display.width > 400
					? 'large'
					: 'small'
					" :icon="questionDialog == true ? 'mdi-chevron-down' : 'mdi-chevron-up'"></v-btn>
				<span :class="$vuetify.display.mdAndDown && $vuetify.display.width > 400
					? 'ml-2'
					: 'ml-2 text-body-2'
					">
					{{ currentQ.qNo }} of
					{{ currentTestJson[currentTestState.sectionIndex].questions.length }}
				</span>
			</v-col>

			<v-col class="text-end align-center">
				<v-btn v-if="$vuetify.display.mdAndUp" size="large" width="150"
					class="submit-btn t-btn text-capitalize btn-rd" elevation="0" @click="betweenSubmitTest"
					color="primary">
					Submit Test
				</v-btn>
				<!-- <v-btn v-if="$vuetify.display.mdAndDown && $vuetify.display.width > 400" density="compact" class="submit-btn-short" size="large" elevation="0" icon="mdi-chevron" @click="betweenSubmitTest" color="primary">
          </v-btn> -->
				<v-btn v-else density="compact" class="submit-btn-short" :size="$vuetify.display.mdAndDown && $vuetify.display.width > 400
					? 'large'
					: 'default'
					" elevation="0" icon="mdi-chevron" @click="betweenSubmitTest" color="primary">
				</v-btn>
				<v-btn v-if="$vuetify.display.mdAndUp" size="large" width="130" class="t-btn text-capitalize btn-rd"
					elevation="0" @click="nextQuestion" color="primary">
					Next
					<template v-slot:append>
						<v-icon color="white">mdi-chevron-right</v-icon>
					</template>
				</v-btn>
				<v-btn v-else density="compact" :size="$vuetify.display.mdAndDown && $vuetify.display.width > 400
					? 'large'
					: 'default'
					" icon="mdi-chevron-right" @click="nextQuestion" color="primary">
				</v-btn>
			</v-col>
		</v-row>
	</v-footer>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";
import HtmlRender from "@/components/Test/HtmlRender.vue";
import {
	AnalyticsEvents,
	recordAnalyticsEvent,
} from "@/services/awsPinpointAnalyticsService";
import { getLocalForageItem, setLocalForageItem } from "@/services/localforageService";
import { convertTestSolutionJsonToCsv, convertTestSolutionJsonToCsvAndUploadToServer, logTestError } from "@/services/logService";

const marked = require("marked");

const renderer = new marked.Renderer();
renderer.link = function link(href, title, text) {
	return `<a href="${href}" title="${title}" target="_blank">${text}</a>`;
};
export default {
	name: "TestQuestionPage",
	data: () => ({
		questionDialog: false,
		submitTimer: null,
		submitTimerTime: 60,
		baseLineClockDrift: 0,
		timeOver: false,
		remaningTimeInSeconds: 0,
		warningDialog: false,
		warningTimeLeft: 10,
		serverTimeCounter: 0,
		intervalId: null,
		serverTime: null,
		reviewScreen: false,
		instructionsDialog: false,
		testInstructionsDialog: false,
		showAttemptedDialog: false,
		disableQuestion: false,
		showSubmitAlert: false,
		showQuestionAttemptAlert: false,
		testSubmitError: false,
		validationErrors: [],
		inputValue: "",
		curentQDuration: {
			qId: "",
			startTime: "",
			endTime: "",
			sentToServer: false,
		},
		currentQResponse: {
			qId: "",
			qType: "",
			checkedOption: "",
			checkedOptions: [],
			integerOption: "",
			decimalOption: "",
			markedForReview: false,
		},
		defualtCurrentQResponse: {
			qId: "",
			qType: "",
			checkedOption: "",
			checkedOptions: [],
			integerOption: "",
			decimalOption: "",
			markedForReview: false,
		},
	}),
	components: {
		HtmlRender,
	},
	async created() {
		this.remaningTimeInSeconds =
			this.syncTimerData.testRemainingDurationInSeconds;
		this.startTimer();
		this.$store.commit("updateTestRoutingAllowed", false);

		this.serverTime = this.syncTimerData.serverTimeStamp;
		this.curentQDuration.startTime = this.serverTime;
		this.baseLineClockDrift = Math.abs(
			this.getCurrentServerTime() - this.getCurrentClientTimeInSeconds()
		);
		// console.log(this.getCurrentServerTime());
		// console.log(this.getCurrentClientTimeInSeconds());
		this.setQIdAndQTypeAfterPrevAndNext();
		setTimeout(() => {
			window.MathJax.typesetPromise();
		}, 0);
	},
	computed: {
		...mapState([
			"currentTestJson",
			"currentTestState",
			"startTestInfo",
			"qResponsesState",
			"syncTimerData",
			"currentTestId",
			"submitError",
			"questionAttemptError",
		]),
		currentQ: {
			get() {
				return this.currentTestJson[this.currentTestState.sectionIndex]
					.questions[this.currentTestState.qIndex];
			},
		},
		currentSection: {
			get() {
				return this.startTestInfo.testmetadata.sections[
					this.currentTestState.sectionIndex
				];
			},
		},
		questionCounts: {
			get() {
				let res = {
					answered: 0,
					marked: 0,
					unanswered: 0,
				};

				let arr = [];

				for (let item of this.qResponsesState) {
					arr.push(...item.responses);
				}

				for (let item of arr) {
					if (item.markedForReview) {
						res.marked++;
					}
					if (this.checkIfQuestionAnswered(item)) {
						res.answered++;
					} else {
						res.unanswered++;
					}
				}
				return res;
			},
		},
		prevButtonDisabled: {
			get() {
				return this.currentTestState.qIndex == 0 &&
					this.currentTestState.sectionIndex == 0
					? true
					: false;
			},
		},
		getRemainingTime: {
			get() {
				if (this.intervalId == null) {
					return "";
				}
				const res = this.toHoursAndMinutes(this.remaningTimeInSeconds);
				return `${this.minTwoDigits(res.h)} : ${this.minTwoDigits(
					res.m
				)} : ${this.minTwoDigits(res.s)}`;
			},
		},
		submitFormattedTime: {
			get() {
				if (this.submitTimer == null) {
					return "";
				}
				const res = this.toHoursAndMinutes(this.submitTimerTime);
				return ` ${this.minTwoDigits(res.m)} : ${this.minTwoDigits(res.s)}`;
			},
		},
	},

	watch: {
		/*currentQResponse(newVal, oldVal) {
		  console.log(`watch currentQResponse.checkedOptions || old: ${JSON.stringify(oldVal.checkedOptions)}`);
		  console.log(`watch currentQResponse.checkedOptions || new: ${JSON.stringify(newVal.checkedOptions)}`);
		},*/
		remaningTimeInSeconds(val) {
			if (val == 600) {
				this.warningDialog = true;
				this.warningTimeLeft = 10;
			}
			if (val == 120) {
				this.warningDialog = true;

				this.warningTimeLeft = 2;
			}
			if (val == 0) {
				clearInterval(this.intervalId);
				// window.alert("time over")
				this.intervalId = null;
				this.updateNextQDurationAndSendLastQToServer();
				this.timeOver = true;
				this.reviewScreen = true;
				//this.submitTest()
				this.submitTimer = setInterval(() => {
					this.submitTimerTime = this.submitTimerTime - 1;
				}, 1000);
			}
		},
		submitTimerTime(val) {
			if (val == 0) {
				clearInterval(this.submitTimer);
				// console.log("submit test");
				recordAnalyticsEvent(AnalyticsEvents.v2TestAutoSubmitTest, {
					testId: this.currentTestId,
					testName: this.startTestInfo.testmetadata.testName,
					testInstanceId: this.startTestInfo.testInstanceId,
				});

				this.$store.commit("updateTestRoutingAllowed", true);

				this.$store.dispatch("submitTest").then(() => {
					
					convertTestSolutionJsonToCsvAndUploadToServer(this.qResponsesState, this.$store.state.selectedTest.testId, this.$store.state.selectedTest.isPractice)
					this.triggerResponseFileDownload();
					if (this.$store.state.selectedTest.isHomework === true) {
						this.$store.dispatch('submitHomeworkTask', { homeworkTaskId: this.$store.state.selectedTest.homeworkTaskId })
					}
					this.$router.replace("/testsubmission");
				});
			}
		},
		currentTestState: {
			handler(newValue) {
				if (
					newValue.qIndex == 0 &&
					this.currentSection.showSectionInstructions
				) {
					this.instructionsDialog = true;
					setTimeout(() => {
						window.MathJax.typesetPromise();
					}, 0);
				}
			},
			deep: true,
		},
	},

	methods: {
		appendValue(value) {
			if (this.currentQ.qType === "3") {
				recordAnalyticsEvent(
					AnalyticsEvents.v2TestInteractionWithQuestionOptions,
					{
						testId: this.currentTestId,
						testName: this.startTestInfo.testmetadata.testName,
						testInstanceId: this.startTestInfo.testInstanceId,
						questionNumber: this.currentQ.qNo,
						questionType: this.currentQ.qType,
						questionOptionsPressedInteraction: value,
						valueOfRecivedInput: `${this.currentQResponse.integerOption}${value}`,
						sectionIndex: this.currentTestState.sectionIndex,
						answerValueBeforeEventRecived: this.currentQResponse.integerOption,
					}
				);
				this.currentQResponse.integerOption = this.currentQResponse.integerOption === null ? `${value}` : `${this.currentQResponse.integerOption}${value}`;
			}
			if (this.currentQ.qType === "4") {
				recordAnalyticsEvent(
					AnalyticsEvents.v2TestInteractionWithQuestionOptions,
					{
						testId: this.currentTestId,
						testName: this.startTestInfo.testmetadata.testName,
						testInstanceId: this.startTestInfo.testInstanceId,
						questionNumber: this.currentQ.qNo,
						questionType: this.currentQ.qType,
						questionOptionsPressedInteraction: value,
						valueOfRecivedInput: `${this.currentQResponse.integerOption}${value}`,
						sectionIndex: this.currentTestState.sectionIndex,
						answerValueBeforeEventRecived: this.currentQResponse.decimalOption,
					}
				);
				this.currentQResponse.decimalOption = this.currentQResponse.decimalOption === null ? `${value}` : `${this.currentQResponse.decimalOption}${value}`;
			}
			this.validateInput();
		},
		clearInput() {
			if (this.currentQ.qType === "3") {
				recordAnalyticsEvent(
					AnalyticsEvents.v2TestInteractionWithQuestionOptions,
					{
						testId: this.currentTestId,
						testName: this.startTestInfo.testmetadata.testName,
						testInstanceId: this.startTestInfo.testInstanceId,
						questionNumber: this.currentQ.qNo,
						questionType: this.currentQ.qType,
						questionOptionsPressedInteraction: "Clear Input",
						valueOfRecivedInput: ``,
						sectionIndex: this.currentTestState.sectionIndex,
						answerValueBeforeEventRecived: this.currentQResponse.integerOption,
					}
				);
				this.currentQResponse.integerOption = "";
			}
			if (this.currentQ.qType === "4") {
				recordAnalyticsEvent(
					AnalyticsEvents.v2TestInteractionWithQuestionOptions,
					{
						testId: this.currentTestId,
						testName: this.startTestInfo.testmetadata.testName,
						testInstanceId: this.startTestInfo.testInstanceId,
						questionNumber: this.currentQ.qNo,
						questionType: this.currentQ.qType,
						questionOptionsPressedInteraction: "Clear Input",
						valueOfRecivedInput: ``,
						sectionIndex: this.currentTestState.sectionIndex,
						answerValueBeforeEventRecived: this.currentQResponse.decimalOption,
					}
				);
				this.currentQResponse.decimalOption = "";
			}
			this.validateInput();
		},
		removeLastCharacter() {
			if (this.currentQ.qType === "3") {
				recordAnalyticsEvent(
					AnalyticsEvents.v2TestInteractionWithQuestionOptions,
					{
						testId: this.currentTestId,
						testName: this.startTestInfo.testmetadata.testName,
						testInstanceId: this.startTestInfo.testInstanceId,
						questionNumber: this.currentQ.qNo,
						questionType: this.currentQ.qType,
						questionOptionsPressedInteraction: "Remove Last Character",
						valueOfRecivedInput: this.currentQResponse.integerOption.slice(
							0,
							-1
						),
						sectionIndex: this.currentTestState.sectionIndex,
						answerValueBeforeEventRecived: this.currentQResponse.integerOption,
					}
				);
				this.currentQResponse.integerOption =
					this.currentQResponse.integerOption.slice(0, -1);
			}
			if (this.currentQ.qType === "4") {
				recordAnalyticsEvent(
					AnalyticsEvents.v2TestInteractionWithQuestionOptions,
					{
						testId: this.currentTestId,
						testName: this.startTestInfo.testmetadata.testName,
						testInstanceId: this.startTestInfo.testInstanceId,
						questionNumber: this.currentQ.qNo,
						questionType: this.currentQ.qType,
						questionOptionsPressedInteraction: "Remove Last Character",
						valueOfRecivedInput: this.currentQResponse.decimalOption.slice(
							0,
							-1
						),
						sectionIndex: this.currentTestState.sectionIndex,
						answerValueBeforeEventRecived: this.currentQResponse.decimalOption,
					}
				);
				this.currentQResponse.decimalOption =
					this.currentQResponse.decimalOption.slice(0, -1);
			}
			this.validateInput();
		},
		validateInput() {
			const validCharacters = /^[-+]?[0-9]*\.?[0-9]*$/;
			if (this.currentQ.qType === "3") {
				if (!validCharacters.test(this.currentQResponse.integerOption)) {
					this.validationErrors = [
						"Only numeric values, - and . are allowed, so for next question please remove alphabets or symbols first",
					];
				} else {
					this.validationErrors = [];
				}
			}
			if (this.currentQ.qType === "4") {
				if (!validCharacters.test(this.currentQResponse.decimalOption)) {
					this.validationErrors = [
						"Only numeric values, - and . are allowed, so for next question please remove alphabets or symbols first",
					];
				} else {
					this.validationErrors = [];
				}
			}
		},
		checkDisableQuestion() {
			if (!this.currentSection.restrictAttemptToMaxQuestion) {
				this.showAttemptedDialog = false;
				this.disableQuestion = false;
				return;
			}
			if (this.checkIfQuestionAnswered(this.currentQResponse)) {
				this.showAttemptedDialog = false;
				this.disableQuestion = false;
				return;
			}
			let check = this.checkIfMaxNumberOfQuestionsAttemptedInASection();
			this.showAttemptedDialog = check;
			this.disableQuestion = check;
		},
		checkIfMaxNumberOfQuestionsAttemptedInASection() {
			let currentSectionMaxAttempt =
				this.currentTestJson[this.currentTestState.sectionIndex]
					.maxQuestionToAttempt;
			let currentSectionResponses =
				this.qResponsesState[this.currentTestState.sectionIndex].responses;
			let count = 0;
			for (let item of currentSectionResponses) {
				let check = this.checkIfQuestionAnswered(item);
				if (check) {
					count = count + 1;
				}
			}

			// console.log("questions answered", count);
			// console.log(currentSectionMaxAttempt);
			if (count >= currentSectionMaxAttempt) {
				//console.log("cannot attempt");
				return true;
			}
			return false;
		},
		getCurrentClientTimeInSeconds() {
			return Math.floor(Date.now() / 1000);
		},
		startTimer() {
			this.intervalId = setInterval(() => {
				this.remaningTimeInSeconds = this.remaningTimeInSeconds - 1;
				this.serverTimeCounter += 1;
			}, 1000);
		},
		minTwoDigits(n) {
			return (n < 10 ? "0" : "") + n;
		},
		openQFromDialog(sIndex, qIndex) {

			if (this.validationErrors.length > 0) {
				this.questionDialog = false;
				return;
			} else {
				this.validationErrors = [];
			}
			// don't do anything if on the same question, needs discussion
			recordAnalyticsEvent(AnalyticsEvents.v2TestQuestionJumpedFromQuestionListPopup, {
				testId: this.currentTestId,
				testName: this.startTestInfo.testmetadata.testName,
				testInstanceId: this.startTestInfo.testInstanceId,
				fromQuestionNumber: this.currentQ.qNo,
				fromSectionIndex: this.currentTestState.sectionIndex,
				fromQuestionType: this.currentQ.qType,
				responseofQuestionIfAny: this.getAnswerValueForQuestionType(),
				toQuestionNumber: qIndex,
				toSectionIndex: sIndex
			});

			this.updateNextQDurationAndSendLastQToServer();
			this.$store.commit("updateCurrentTestState", {
				qIndex: qIndex,
				sectionIndex: sIndex,
			});

			this.setQIdAndQTypeAfterPrevAndNext();
			this.questionDialog = false;

			setTimeout(() => {
				window.MathJax.typesetPromise();
			}, 0);
			this.checkDisableQuestion();
		},
		openQFromReview(sIndex, qIndex) {
			// this.updateNextQDurationAndSendLastQToServer()

			// don't do anything if on the same question, needs discussion

			this.curentQDuration.startTime = this.getCurrentServerTime();

			this.$store.commit("updateCurrentTestState", {
				qIndex: qIndex,
				sectionIndex: sIndex,
			});

			this.setQIdAndQTypeAfterPrevAndNext();
			this.reviewScreen = false;

			setTimeout(() => {
				window.MathJax.typesetPromise();
			}, 0);
			this.checkDisableQuestion();
		},
		getMarkDownHtml(markdown) {
			if (markdown == null) {
				return "";
			}
			let markDownText = markdown;
			let out = false;
			const regex = /\\/gm;
			const escapedString = markDownText.replace(regex, "\\\\");

			out = marked.parseInline(escapedString, { renderer });

			return out;
		},
		getQuestionCountByClassification() {
			let res = {
				answered: 0,
				marked: 0,
				unanswered: 0,
			};

			let arr = [];

			for (let item of this.qResponsesState) {
				arr.push(...item.responses);
			}

			for (let item of arr) {
				if (item.markedForReview) {
					res.marked++;
				}
				if (this.checkIfQuestionAnswered(item)) {
					res.answered++;
				} else {
					res.unanswered++;
				}
			}
			return res;
		},
		betweenSubmitTest() {

			if (this.validationErrors.length > 0) return;
			else this.validationErrors = [];
			//console.log(JSON.stringify(this.qResponsesState, null, 2));
			let questionCountData = this.getQuestionCountByClassification();
			//console.log("question Count Data after submit button preessed", questionCountData);
			recordAnalyticsEvent(
				AnalyticsEvents.v2TestSubmitButtonClickedDuringTest,
				{
					testId: this.currentTestId,
					testName: this.startTestInfo.testmetadata.testName,
					testInstanceId: this.startTestInfo.testInstanceId,
					answeredQuestions: questionCountData.answered,
					markedQuestions: questionCountData.marked,
					unanswered: questionCountData.unanswered
				}
			);
			this.updateNextQDurationAndSendLastQToServer();
			this.reviewScreen = true;
		},
		getAnswerValueForQuestionType() {
			if (this.currentQResponse.qType == 1) {
				return this.currentQResponse.checkedOption == null || this.currentQResponse.checkedOption.length == 0
					? "Not Answered"
					: this.currentQResponse.checkedOption;
			}
			if (this.currentQResponse.qType == 2) {
				return this.currentQResponse.checkedOptions == null || this.currentQResponse.checkedOptions.length == 0
					? "Not Answered"
					: JSON.stringify(this.currentQResponse.checkedOptions);
			}
			if (this.currentQResponse.qType == 3) {
				return this.currentQResponse.integerOption == null || this.currentQResponse.integerOption.length == 0
					? "Not Answered"
					: this.currentQResponse.integerOption;
			}
			if (this.currentQResponse.qType == 4) {
				return this.currentQResponse.decimalOption == null || this.currentQResponse.decimalOption.length == 0
					? "Not Answered"
					: this.currentQResponse.decimalOption;
			}
		},
		nextQuestion() {
			this.updateNextQDurationAndSendLastQToServer();



			if (this.validationErrors.length > 0) return;
			else this.validationErrors = [];


			if (
				this.currentTestState.qIndex ==
				this.currentTestJson[this.currentTestState.sectionIndex].questions
					.length -
				1
			) {
				if (
					this.currentTestState.sectionIndex ==
					this.currentTestJson.length - 1
				) {
					//console.log("review");
					this.reviewScreen = true;
				} else {
					this.$store.commit("updateCurrentTestState", {
						qIndex: 0,
						sectionIndex: this.currentTestState.sectionIndex + 1,
					});
				}
			} else {
				// changes ui to next question
				this.$store.commit("updateCurrentTestState", {
					qIndex: this.currentTestState.qIndex + 1,
					sectionIndex: this.currentTestState.sectionIndex,
				});
			}
			this.setQIdAndQTypeAfterPrevAndNext();

			setTimeout(() => {
				window.MathJax.typesetPromise();
			}, 0);

			this.checkDisableQuestion();
			recordAnalyticsEvent(AnalyticsEvents.v2TestNextButtonClicked, {
				testId: this.currentTestId,
				testName: this.startTestInfo.testmetadata.testName,
				testInstanceId: this.startTestInfo.testInstanceId,
				questionNumber: this.currentQ.qNo,
				questionType: this.currentQ.qType,
				currentQResponse: this.getAnswerValueForQuestionType(),
				sectionIndex: this.currentTestState.sectionIndex,
			});
		},
		prevQuestion() {


			this.updateNextQDurationAndSendLastQToServer();


			if (this.validationErrors.length > 0) return;
			else this.validationErrors = [];


			if (this.currentTestState.qIndex == 0) {
				if (this.currentTestState.sectionIndex == 0) {
					console.log("first section");
				} else {
					this.$store.commit("updateCurrentTestState", {
						qIndex:
							this.currentTestJson[this.currentTestState.sectionIndex - 1]
								.questions.length - 1,
						sectionIndex: this.currentTestState.sectionIndex - 1,
					});
				}
			} else {
				// changes ui to next question
				this.$store.commit("updateCurrentTestState", {
					qIndex: this.currentTestState.qIndex - 1,
					sectionIndex: this.currentTestState.sectionIndex,
				});
			}

			this.setQIdAndQTypeAfterPrevAndNext();

			setTimeout(() => {
				window.MathJax.typesetPromise();
			}, 0);
			this.checkDisableQuestion();
			recordAnalyticsEvent(AnalyticsEvents.v2TestPreviousButtonPressed, {
				testId: this.currentTestId,
				testName: this.startTestInfo.testmetadata.testName,
				testInstanceId: this.startTestInfo.testInstanceId,
				questionNumber: this.currentQ.qNo,
				questionType: this.currentQ.qType,
				currentQResponse: this.getAnswerValueForQuestionType(),
				sectionIndex: this.currentTestState.sectionIndex,
			});
		},
		updateNextQDurationAndSendLastQToServer() {
			try {
				this.showQuestionAttemptAlert = false;
				this.$store.commit("updateQuestionAttemptError", "");
				this.checkClockDrift();
				const lastAttemptQDuration = _.cloneDeep(this.curentQDuration);
				const lasAttemptQResponse = _.cloneDeep(this.currentQResponse);
				//

				if (!Array.isArray(lasAttemptQResponse.checkedOptions)) {
					lasAttemptQResponse.checkedOptions = [
						lasAttemptQResponse.checkedOptions,
					]; //[null]
				}

				if (Array.isArray(lasAttemptQResponse.checkedOption)) {
					lasAttemptQResponse.checkedOption =
						lasAttemptQResponse.checkedOption[0]; //[null]
				}
				lastAttemptQDuration.endTime = this.getCurrentServerTime();

				this.curentQDuration.startTime = this.getCurrentServerTime();

				recordAnalyticsEvent(AnalyticsEvents.v2TestQuestionResponseSentToServer, {
					testId: this.currentTestId,
					testName: this.startTestInfo.testmetadata.testName,
					testInstanceId: this.startTestInfo.testInstanceId,
					questionNumber: this.currentQ.qNo,
					questionType: this.currentQ.qType,
					currentQResponse: this.getAnswerValueForQuestionType(),
					sectionIndex: this.currentTestState.sectionIndex,
				});

				this.$store
					.dispatch("updateQuestionDurationAndResponse", {
						qDuration: lastAttemptQDuration,
						qResponse: lasAttemptQResponse,
					})
					.then(() => {
						if (
							this.questionAttemptError.length !== 0 &&
							(lasAttemptQResponse.checkedOption === null || lasAttemptQResponse.checkedOption.length === 0) &&
							(lasAttemptQResponse.checkedOptions === null || lasAttemptQResponse.checkedOptions.length === 0) &&
							(lasAttemptQResponse.integerOption === null || lasAttemptQResponse.integerOption.length === 0) &&
							(lasAttemptQResponse.decimalOption === null || lasAttemptQResponse.decimalOption.length === 0)
						) {
							this.showQuestionAttemptAlert = false;
						} else if (this.questionAttemptError.length !== 0) {
							this.showQuestionAttemptAlert = true;
						}
					}).catch(err => {
						logTestError(err, this.startTestInfo.testmetadata.testName, this.currentTestId, this.startTestInfo.testInstanceId, `Question Attempt Error - Test Question Page, Attempt API Failed for Question Number: ${this.currentQ.qNo}`);
						recordAnalyticsEvent(AnalyticsEvents.v2TestUserAttemptMethodInStoreFailed, {
							message: `userAttemptInStoreFailed`,
							error: JSON.stringify(err.stack).slice(0, 199),
							testId: this.currentTestId,
							testName: this.startTestInfo.testmetadata.testName,
							testInstanceId: this.startTestInfo.testInstanceId,
							questionNumber: this.currentQ.qNo,
							questionType: this.currentQ.qType,
							currentQResponse: this.getAnswerValueForQuestionType(),
							sectionIndex: this.currentTestState.sectionIndex,
							qDuration: JSON.stringify(lastAttemptQDuration),
							qResponse1: JSON.stringify(lasAttemptQResponse).slice(0, 156),
							qResponse2: JSON.stringify(lasAttemptQResponse).slice(156),
						});

						this.$store.dispatch("recordError", { Error: JSON.stringify(err.stack), API: "API_userAttemptInStoreFailed" }).then().catch(err => {
							recordAnalyticsEvent(AnalyticsEvents.v2TestRecordErrorAPIFailed, {
								message: `recordErrorAPIFailedFoStoreUserAttemptMethod`,
								error: JSON.stringify(err.stack).slice(0, 199),
							});
						});
						this.showQuestionAttemptAlert = true;
						setLocalForageItem('qDurations', [])
						setLocalForageItem('qResponses', [])
					})
			} catch (err) {
				logTestError(err, this.startTestInfo.testmetadata.testName, this.currentTestId, this.startTestInfo.testInstanceId, `Question Attempt Error - Test Question Page, Attempt Method Failed for Question Number: ${this.currentQ.qNo}`);
				recordAnalyticsEvent(AnalyticsEvents.v2TestUserAttemptMethodInTestQuestionPageFailed, {
					message: `userAttemptInTestQuestionPageFailed`,
					error: JSON.stringify(err.stack).slice(0, 199),
					testId: this.currentTestId,
					testName: this.startTestInfo.testmetadata.testName,
					testInstanceId: this.startTestInfo.testInstanceId,
					questionNumber: this.currentQ.qNo,
					questionType: this.currentQ.qType,
					currentQResponse: this.getAnswerValueForQuestionType(),
					sectionIndex: this.currentTestState.sectionIndex,
					qDuration: JSON.stringify(this.curentQDuration),
					qResponse1: JSON.stringify(this.currentQResponse).slice(0, 156),
					qResponse2: JSON.stringify(this.currentQResponse).slice(156),
				});

				this.$store.dispatch("recordError", { Error: JSON.stringify(err.stack), API: "Method_userAttemptInTestQuestionPageFailed" }).then().catch((err) => {
					recordAnalyticsEvent(AnalyticsEvents.v2TestRecordErrorAPIFailed, {
						message: `recordErrorAPIFailedForTestQuestionPageUserAttemptMethod`,
						error: JSON.stringify(err.stack).slice(0, 199),
					});
				});
				this.showQuestionAttemptAlert = true;

				setLocalForageItem('qDurations', [])
				setLocalForageItem('qResponses', [])
			}
		},
		toHoursAndMinutes(totalSeconds) {
			const totalMinutes = Math.floor(totalSeconds / 60);
			const seconds = totalSeconds % 60;
			const hours = Math.floor(totalMinutes / 60);
			const minutes = totalMinutes % 60;
			return { h: parseInt(hours), m: parseInt(minutes), s: parseInt(seconds) };
		},
		getCurrentServerTime() {
			return this.serverTime + this.serverTimeCounter;
		},
		setQIdAndQTypeAfterPrevAndNext() {
			this.currentQResponse =
				this.qResponsesState[this.currentTestState.sectionIndex].responses[
				this.currentTestState.qIndex
				];
			if (!Array.isArray(this.currentQResponse.checkedOptions)) {
				//console.log(`updated null currentQResponse to empty array []`)
				this.currentQResponse.checkedOptions = [];
			}
			this.curentQDuration.qId =
				this.currentTestJson[this.currentTestState.sectionIndex].questions[
					this.currentTestState.qIndex
				].qId;
			this.curentQDuration.sectionId =
				this.currentTestJson[this.currentTestState.sectionIndex].sectionId;
		},
		clearResponse() {
			recordAnalyticsEvent(AnalyticsEvents.v2TestClearResponseButtonPressed, {
				testId: this.currentTestId,
				testName: this.startTestInfo.testmetadata.testName,
				testInstanceId: this.startTestInfo.testInstanceId,
				questionNumber: this.currentQ.qNo,
				questionType: this.currentQ.qType,
				currentQResponseBeforeClear: this.getAnswerValueForQuestionType(),
				sectionIndex: this.currentTestState.sectionIndex,
			});
			this.currentQResponse.checkedOption = "";
			this.currentQResponse.checkedOptions = [];
			this.currentQResponse.integerOption = "";
			this.currentQResponse.decimalOption = "";
			this.validateInput();
		},
		getTypeOfQuestionCounts() {
			let res = {
				answered: 0,
				marked: 0,
				unanswered: 0,
			};

			for (let item of this.qResponsesState) {
				if (item.markedForReview) {
					res.marked++;
				}
				if (this.checkIfQuestionAnswered(item)) {
					res.answered += res.answered;
				} else {
					res.unanswered += res.unanswered;
				}

				return res;
			}
		},
		checkIfQuestionAnswered(q) {
			if (q.qType == 1) {
				return q.checkedOption == null || q.checkedOption.length == 0
					? false
					: true;
			}
			if (q.qType == 2) {
				return q.checkedOptions == null || q.checkedOptions.length == 0
					? false
					: true;
			}
			if (q.qType == 3) {
				return q.integerOption == null || q.integerOption.length == 0
					? false
					: true;
			}
			if (q.qType == 4) {
				return q.decimalOption == null || q.decimalOption.length == 0
					? false
					: true;
			}
		},
		checkClockDrift() {
			// console.log(this.getCurrentClientTimeInSeconds());
			// console.log(this.getCurrentServerTime());

			let currentDrift = Math.abs(
				this.getCurrentClientTimeInSeconds() - this.getCurrentServerTime()
			);
			// console.log(currentDrift);
			// console.log(this.baseLineClockDrift);

			if (Math.abs(currentDrift - this.baseLineClockDrift) >= 10) {
				//console.log("drift limit exceeded, get time form server");
				this.resetTimer();
				recordAnalyticsEvent(AnalyticsEvents.v2TestClockDriftHappened, {
					currentDrift,
					baseLineClockDrift: this.baseLineClockDrift
				});
			}
		},
		backFromReview() {
			this.testSubmitError = false;
			recordAnalyticsEvent(AnalyticsEvents.v2TestBackFromReviewPageClicked);
			this.curentQDuration.startTime = this.getCurrentServerTime();
			this.setQIdAndQTypeAfterPrevAndNext();
			this.reviewScreen = false;
			setTimeout(() => {
				window.MathJax.typesetPromise();
			}, 0);
			// get request : with testInstanceId
		},
		resetTimer() {
			this.$store.dispatch("updateSyncTimer", { state: "sync" }).then(() => {
				clearInterval(this.intervalId);
				this.remaningTimeInSeconds =
					this.syncTimerData.testRemainingDurationInSeconds;
				this.serverTime = this.syncTimerData.serverTimeStamp;
				this.serverTimeCounter = 0;

				this.baseLineClockDrift = Math.abs(
					this.getCurrentServerTime() - this.getCurrentClientTimeInSeconds()
				);
				this.startTimer();
				recordAnalyticsEvent(AnalyticsEvents.v2TestUpdateSyncTimerCalledBetweenTest, {
					syncTimerDataRecivedFromServer: this.syncTimerData.testRemainingDurationInSeconds,
					serverTimeStamp: this.syncTimerData.serverTimeStamp,
					baseLineClockDrift: this.baseLineClockDrift
				});
			});
		},
		showInstructions() {
			recordAnalyticsEvent(
				AnalyticsEvents.v2TestSectionInstructionsDuringTest,
				{
					testId: this.currentTestId,
					testName: this.startTestInfo.testmetadata.testName,
					testInstanceId: this.startTestInfo.testInstanceId,
					sectionId: this.currentSection.sectionId,
				}
			);
			this.instructionsDialog = true;
			setTimeout(() => {
				window.MathJax.typesetPromise();
			}, 10);
		},
		triggerResponseFileDownload() {
			// console.log(this.qResponsesState);
			convertTestSolutionJsonToCsv(this.qResponsesState, this.$store.state.selectedTest.testName, this.$store.state.selectedTest.isPractice);
		},
		submitTest() {
			try {
				this.testSubmitError = false;

				this.showQuestionAttemptAlert = false;
				this.showSubmitAlert = false;
				this.$store.commit("updateTestRoutingAllowed", true);
				this.$store.commit("updateSubmitError", "");

				this.$store.dispatch("submitTest").then(() => {
					//console.log(this.submitError);
					if (this.$store.state.selectedTest.isHomework === true) {
						this.$store.dispatch('submitHomeworkTask', { homeworkTaskId: this.$store.state.selectedTest.homeworkTaskId })
					}
					if (this.submitError.length == 0) {
						//console.log("test selected", this.$store.state.selectedTest);
						convertTestSolutionJsonToCsvAndUploadToServer(this.qResponsesState, this.$store.state.selectedTest.testId, this.$store.state.selectedTest.isPractice)
						this.$router.replace("/testsubmission");
					} else {
						logTestError({}, this.startTestInfo.testmetadata.testName, this.currentTestId, this.startTestInfo.testInstanceId, "Submit Test Network Error");
						this.showSubmitAlert = true;
						this.testSubmitError = true;
					}
				}).catch(err => {
					logTestError(err, this.startTestInfo.testmetadata.testName, this.currentTestId, this.startTestInfo.testInstanceId, "Submit Test API Error")
					this.testSubmitError = true;
				});
				let questionCountData = this.getQuestionCountByClassification();

				recordAnalyticsEvent(AnalyticsEvents.v2TestSubmitTest, {
					testId: this.currentTestId,
					testName: this.startTestInfo.testmetadata.testName,
					testInstanceId: this.startTestInfo.testInstanceId,
					answeredQuestions: questionCountData.answered,
					markedQuestions: questionCountData.marked,
					unanswered: questionCountData.unanswered
				});
			} catch (err) {
				logTestError(err, this.startTestInfo.testmetadata.testName, this.currentTestId, this.startTestInfo.testInstanceId, "Test submit page - Submit Test Error");
				this.testSubmitError = true;
			}

		},
		showTestInstructionsDialog() {
			recordAnalyticsEvent(AnalyticsEvents.v2TestInstructionsDuringTest, {
				testId: this.currentTestId,
				testName: this.startTestInfo.testmetadata.testName,
				testInstanceId: this.startTestInfo.testInstanceId,
			});
			this.testInstructionsDialog = true;
			setTimeout(() => {
				window.MathJax.typesetPromise();
			}, 10);
		},
		async exitTest() {
			//this.$router.back()
			let collectionId = await getLocalForageItem("collectionId");
			console.log(collectionId);
			if (this.$store.state.selectedTest.isHomework === true) {
				this.$router.push(`/homework`);
			} else if (collectionId != null) {
				this.$router.replace(`/testseries/${collectionId}/0`);
			}
			let questionCountData = this.getQuestionCountByClassification();
			//console.log("question Count Data on exit test", questionCountData);
			recordAnalyticsEvent(AnalyticsEvents.v2TestExitInProgressTest, {
				testId: this.currentTestId,
				testName: this.startTestInfo.testmetadata.testName,
				testInstanceId: this.startTestInfo.testInstanceId,
				answeredQuestions: questionCountData.answered,
				markedQuestions: questionCountData.marked,
				unanswered: questionCountData.unanswered
			});
		},
		openQuestionDialog() {
			recordAnalyticsEvent(AnalyticsEvents.v2TestQuestionListPopupOpen, {
				testId: this.currentTestId,
				testName: this.startTestInfo.testmetadata.testName,
				testInstanceId: this.startTestInfo.testInstanceId,
				questionNumber: this.currentQ.qNo,
				sectionIndex: this.currentTestState.sectionIndex,
			});
			this.questionDialog = true;
		},
		eventCaptureForQTypeOne(option) {
			//console.log("Qestion type one event cliked", option);
			recordAnalyticsEvent(
				AnalyticsEvents.v2TestInteractionWithQuestionOptions,
				{
					testId: this.currentTestId,
					testName: this.startTestInfo.testmetadata.testName,
					testInstanceId: this.startTestInfo.testInstanceId,
					questionNumber: this.currentQ.qNo,
					questionType: this.currentQ.qType,
					questionOptionsPressedInteraction: option.key,
					sectionIndex: this.currentTestState.sectionIndex,
					answerValueBeforeEventRecived: JSON.stringify(
						this.currentQResponse.checkedOption
					),
				}
			);
		},
		eventCaptureForQTypeTwo(option) {
			//console.log("Qestion type one event cliked", option);
			recordAnalyticsEvent(
				AnalyticsEvents.v2TestInteractionWithQuestionOptions,
				{
					testId: this.currentTestId,
					testName: this.startTestInfo.testmetadata.testName,
					testInstanceId: this.startTestInfo.testInstanceId,
					questionNumber: this.currentQ.qNo,
					questionType: this.currentQ.qType,
					questionOptionsPressedInteraction: option.key,
					sectionIndex: this.currentTestState.sectionIndex,
					answerValueBeforeEventRecived: JSON.stringify(
						this.currentQResponse.checkedOptions
					),
				}
			);
		},
		eventCaptureForMarkReview() {
			recordAnalyticsEvent(AnalyticsEvents.v2TestQuestionMarkedForReview, {
				testId: this.currentTestId,
				testName: this.startTestInfo.testmetadata.testName,
				testInstanceId: this.startTestInfo.testInstanceId,
				questionNumber: this.currentQ.qNo,
				questionType: this.currentQ.qType,
				sectionIndex: this.currentTestState.sectionIndex,
				answeredValue: this.getAnswerValueForQuestionType(),
				isMarkedForReview: this.currentQResponse.markedForReview,
			});
		},
	},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.numeric-input {
	display: inline-block;
}

.input-charactors {
	padding: 20px;
	box-sizing: content-box;
	background-color: #ebebeb;
	border-radius: 5px;
	box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 20px;
}

input[type="text"] {
	width: calc(100% - 10px);
	margin-bottom: 10px;
}

.buttons {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	grid-gap: 5px;
}

.backspace-btn {
	width: 100%;
	height: 30px;
	border: 1px solid black;
	margin-bottom: 5px;
	border-radius: 10px;
	background-color: white;
}

.backspace-btn:hover {
	box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 12px;
}

.clear-btn {
	border-radius: 10px;
	width: 100%;
	border: 1px solid black;
	margin-top: 5px;
	box-sizing: content-box;
	height: 30px;
	background-color: white;
}

.clear-btn:hover {
	box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 12px;
}

.text-input-btn {
	border-radius: 5px;
	width: calc(100%);
	height: 30px;
	border: 1px solid black;
	background-color: white;
}

.text-input-btn:hover {
	box-shadow: rgba(0, 0, 0, 0.2) 0px 4px 12px;
}

.submit-btn {
	margin-right: 50px;
	background-color: rgb(64, 130, 57) !important;
}

.submit-btn-short {
	margin-right: 10px;
	background-color: rgb(64, 130, 57) !important;
}

.correct {
	background: #26b99aa6 !important;
	color: white !important;
}

.img {
	vertical-align: middle;
}

.success {
	background: #26b99aa6 !important;
}

.timer-color {
	color: #26b99aa6 !important;
}

.unanswered {
	border: 2px solid #949494 !important;
}

.marked {
	border: 2.5px solid #ff894f !important;
}

.option {
	/* box-shadow: 0px 2px 8px rgba(112, 144, 240, 0.2) !important; */
	border-radius: 10px;
	border: 1px rgb(var(--v-theme-secondaryBackground)) solid;
}

.v-sheet.on-hover {
	cursor: pointer;
	/* border: 1px solid rgb(var(--v-theme-primary)); */
	border-color: transparent;
	background-color: white;
	box-shadow: 0px 2px 8px rgba(112, 144, 240, 0.2) !important;
}

.bx {
	background-color: rgb(var(--v-theme-navColor));
	border: 1px solid #e7e7e7;
	border-radius: 4px;
}

.card-bg-color {
	background-color: rgb(var(--v-theme-navColor)) !important;
	border: 0.5px solid rgba(0, 0, 0, 0.15) !important;
	border-radius: 12px !important;
}

.outline-color {
	border-color: rgb(var(--v-theme-secondaryBackground)) !important;
}

.bottom {
	position: absolute !important;
	bottom: 10px !important;
}

.v-overlay__content {
	position: absolute !important;
	bottom: 10px !important;
}

.blink {
	animation: blinker 1s step-start infinite;
}

@keyframes blinker {
	50% {
		opacity: 0;
	}
}

.qNoClass {
	font-size: 0.875rem;
}

.dialog-bx {
	position: fixed !important;
}
</style>


<style>
.htmlClassTestOption span {
	top: 0 !important;
	vertical-align: middle;
}

.htmlClassTest span {
	top: 0 !important;
	vertical-align: middle;
}

/* .htmlClassTest img {
  top: 0 !important;
  vertical-align: middle;
  max-width: 100%;
  height: auto;
} */

.testOption .v-selection-control--inline {
	min-width: 100% !important;
}

.testOption .v-label {
	width: 100% !important;
	opacity: 1 !important;
}

.v-label {
	opacity: 1 !important;
}
</style>
